import { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AddSGBPCategoryData } from "./data/AddSGBPCategory.Data";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";
import Accordion from "../../../components/Accordion/Accordion";
import { useApproveSGBPCategoryCriteriaCertificateMappingByIdMutation, useGetL1DropdownByChannelIdMutation, useLazyGetAllDropdownForCRUDCategoryQuery, useLazyGetCategoryCriteriaCertificateMappingByIdQuery, useUpdateCategoryCriteriaCertificateMappingInformationMutation } from "../../../app/services/Crud/crudApi";
import SwalAlert from "../../../services/swalService/SwalService";
import { setAllDropDownField } from "../approveSGBPCategory/Utils/setAllDropDownField";
import { applyCertificateTemplateOptions, getCertificateTemplateOptions, hideAndShowFields, setFieldParameter } from "../approveSGBPCategory/Utils/setFormUtils";
import { decryptAESID } from "../../../utils/Encryption";

const ApproveCategory = () => {
    const editSGBPCategoryRefs = useRef();
    const navigate = useNavigate();
    const { id } = useParams();
    const editID = decryptAESID(id, false);
    const [formData, setFormData] = useState(AddSGBPCategoryData);
    const { error, success } = SwalAlert();
    const [getDropdowns, { data: dropdownData, isLoading: dropdownLoading },] = useLazyGetAllDropdownForCRUDCategoryQuery();
    const [updateMapping, { data: mappingData, isLoading: mappingLoading },] = useUpdateCategoryCriteriaCertificateMappingInformationMutation();
    const [getCategoryCriteriaCertificateMapping, { data: categoryCriteriaCertificateMappingData, isLoading: categoryCriteriaCertificateMappingLoading, },] = useLazyGetCategoryCriteriaCertificateMappingByIdQuery();
    const [approveCategoryCriteriaCertificate, { data: approveCategoryCriteriaCertificateData, isLoading: approveCategoryCriteriaCertificateLoading },] = useApproveSGBPCategoryCriteriaCertificateMappingByIdMutation();
    const [getL1DropdownByChannelId, { data: l1DropdownData, isLoading: l1DropdownLoading, }] = useGetL1DropdownByChannelIdMutation();


    useEffect(() => {
        getDropdowns();
        if (editID) {
            getCategoryCriteriaCertificateMapping(editID);
        }
    }, [id])

    useEffect(() => {
        if (!approveCategoryCriteriaCertificateLoading && approveCategoryCriteriaCertificateData) {
            success("Category - Criteria approved successfully.");
            navigate("/approveSGBPCategory");
        }
    }, [approveCategoryCriteriaCertificateLoading, approveCategoryCriteriaCertificateData]);

    useEffect(() => {
        if (!dropdownLoading && dropdownData) {
            setAllDropDownField(dropdownData);
        }
    }, [dropdownLoading, dropdownData]);

    useEffect(() => {
        if (!categoryCriteriaCertificateMappingLoading && categoryCriteriaCertificateMappingData) {
            getL1DropdownByChannelId({ ChannelId: categoryCriteriaCertificateMappingData?.channelId })
            setFormData((prev) => {
                let updatedForm = hideAndShowFields(prev, { value: categoryCriteriaCertificateMappingData?.channelId });
                return {
                    ...updatedForm, initialState: {
                        ...updatedForm.initialState,
                        channel: categoryCriteriaCertificateMappingData?.channelId,
                        category: categoryCriteriaCertificateMappingData?.categoryL1Id || categoryCriteriaCertificateMappingData?.categoryL1Id,
                        subCategory: categoryCriteriaCertificateMappingData?.subCategoryL2Id,
                        type: categoryCriteriaCertificateMappingData?.typeL3Id,
                        code: categoryCriteriaCertificateMappingData?.criteriaCodeId,
                        certificateTemplate: categoryCriteriaCertificateMappingData?.certificateTemplateId,
                    },
                };
            });
            // }
        }
    }, [categoryCriteriaCertificateMappingLoading, categoryCriteriaCertificateMappingData]);

    useEffect(() => {
        // if (l1DropdownData && !l1DropdownLoading) {
        //     const filterDropdown = l1DropdownData?.map((item) => ({ value: item.id, label: item.name }));
        //     // setFormData((prev) => {
        //     //     let updatedForm = { ...prev };
        //     //     updatedForm = { ...updatedForm, formFields: updatedForm.formFields.map(field => field.id === "category" ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown, }, } : field), };
        //     //     return updatedForm;
        //     // });
        //     setFormData(prev => {
        //         let updated = { ...prev };
        //         updated.formFields = updated.formFields.map(field => {
        //             if (field.id === "category") {
        //                 return {
        //                     ...field,
        //                     fieldSetting: {
        //                         ...field.fieldSetting,
        //                         options: filterDropdown,
        //                         // isDisable: categoryCriteriaCertificateMappingData?.statusId == 9
        //                     }
        //                 };
        //             }
        //             return field;
        //         });
        //         updated.initialState.category = l1DropdownData?.length > 0 ? categoryCriteriaCertificateMappingData?.categoryL1Id : null;
        //         return updated;
        //     });
        // }
        if (l1DropdownData && !l1DropdownLoading) {
            const filterDropdown = l1DropdownData.map((item) => ({ value: item.id, label: item.name }));
            setFormData((prev) => ({
                ...prev,
                formFields: prev.formFields.map((field) =>
                    field.id === "category"
                        ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown } }
                        : field
                ),
            }));
        }
    }, [l1DropdownData, l1DropdownLoading]);

    useEffect(() => {
        if (!dropdownData || !categoryCriteriaCertificateMappingData) return;
        const options = getCertificateTemplateOptions(dropdownData, categoryCriteriaCertificateMappingData.channelId);
        setFormData((prev) => applyCertificateTemplateOptions(prev, options));
    }, [dropdownData, categoryCriteriaCertificateMappingData]);

    useEffect(() => {
        if (!mappingLoading && mappingData) {
            if (mappingData?.errorMessage === "Criteria Mapping Already Exist") {
                error("Criteria Mapping Already Exist.");
            }
            else {
                success("Criteria mapping updated successfully.", "");
                resetForm()
                navigate('/approveSGBPCategory')
            }
        }
    }, [mappingLoading, mappingData]);

    const handleSubmit = () => {
        const data = editSGBPCategoryRefs?.current?.getFormData();
        if (!data) {
            error("Please fill in all mandatory fields to continue.", "")
            return;
        }

        const request = {
            SGBPCategoryCriteriaCertificateMappingId: editID,
            ChannelId: data.channel?.value || data.channel,
            CategoryL1Id: data.category?.value || data.category,
            SubCategoryL2Id: data.channel?.value == 1 || data.channel == 1 ? data.subCategory?.value || data.subCategory : null,
            TypeL3Id: data.channel?.value == 1 || data.channel == 1 ? data.type?.value || data.type : null,
            CriteriaCodeId: data.code?.value || data.code,
            CertificateTemplateId: data.certificateTemplate?.value || data.certificateTemplate,
        }
        updateMapping(request);
    }

    const handleFormFieldChange = async (dataField, value) => {
        let updatedForm = { ...formData };
        if (dataField === "channel") {
            updatedForm = hideAndShowFields(updatedForm, value);
            const apiResponse = await getL1DropdownByChannelId({ ChannelId: value?.value });
            const filterDropdown = apiResponse?.data?.map((item) => ({ value: item.id, label: item.name }));
            const categoryOptions = apiResponse?.data?.map((item) => ({ value: item.id, label: item.name })) || [];
            const templateOptions = getCertificateTemplateOptions(dropdownData, value?.value);

            // let updatedFormData = { ...updatedForm, initialState: { ...updatedForm.initialState, channel: value, category: null, subCategory: null, type: null, } };
            // updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "category" ? { ...field, fieldSetting: { ...field.fieldSetting, options: filterDropdown, }, } : field), };
            // setFormData(updatedFormData);
            setFormData((prev) => {
                let form = hideAndShowFields(prev, value);
                form = {
                    ...form,
                    initialState: {
                        ...form.initialState,
                        channel: value,
                        category: null,
                        subCategory: null,
                        type: null,
                        certificateTemplate: null,
                    },
                    formFields: form.formFields.map((field) =>
                        field.id === "category"
                            ? { ...field, fieldSetting: { ...field.fieldSetting, options: categoryOptions } }
                            : field
                    ),
                };
                return applyCertificateTemplateOptions(form, templateOptions);
            });
        } else {
            // update field value safely
            // setFormData((prev) => ({ ...prev, ...updatedForm, initialState: { ...prev.initialState, ...updatedForm.initialState, [dataField]: value, }, }));
            setFormData((prev) => ({ ...prev, initialState: { ...prev.initialState, [dataField]: value }, }));
        };
    };

    const resetForm = () => {
        const resetData = {
            ...AddSGBPCategoryData,
            initialState: {
                channel: null,
                category: null,
                subCategory: null,
                type: null,
                code: null,
                certificateTemplate: null
            },
        };
        setFormData(resetData);

    };

    const handleBack = () => {
        navigate('/approveSGBPCategory');
        resetForm();
    }

    const handleApprove = () => {
        const request = {
            SGBPCategoryCriteriaCertificateMappingId: editID
        }
        approveCategoryCriteriaCertificate(request)
    }

    return (
        <div className="add-requirement">
            <Suspense fallback={<DataLoader />}>
                <Accordion
                    title="Edit Criteria Mapping"
                    className="mb-4"
                    button={false}
                    accordion={false}
                >
                    <div className="row">
                        {dropdownData && categoryCriteriaCertificateMappingData &&
                            <FormCreator
                                ref={editSGBPCategoryRefs}
                                {...formData}
                                onFormFieldValueChange={handleFormFieldChange}
                            />
                        }
                    </div>
                </Accordion>
                <div className="add-requirement-btn-wrapper">
                    <Buttons
                        buttonText="Back"
                        buttonTypeClassName="btn btn-secondary mb-2"
                        onClick={handleBack}
                    />
                    {categoryCriteriaCertificateMappingData?.statusId == 9 ?
                        <div className="save-btn-wrapper">
                            <Buttons
                                buttonText="Approve"
                                buttonTypeClassName="approve-btn"
                                isDisable={true}
                            />
                            <Buttons
                                buttonText="Save"
                                buttonTypeClassName="add-btn"
                                isDisable={true}
                            />
                        </div>
                        :
                        <div className="save-btn-wrapper">
                            <Buttons
                                buttonText="Approve"
                                buttonTypeClassName="approve-btn"
                                onClick={handleApprove}
                                isLoading={approveCategoryCriteriaCertificateLoading}
                                isDisable={approveCategoryCriteriaCertificateLoading}
                            />
                            <Buttons
                                buttonText="Save"
                                buttonTypeClassName="add-btn"
                                onClick={handleSubmit}
                            />
                        </div>
                    }
                </div>

            </Suspense>
        </div>
    );
};

export default ApproveCategory;
